import { render, staticRenderFns } from "./TabSeo.vue?vue&type=template&id=5d751488"
import script from "./TabSeo.vue?vue&type=script&lang=js"
export * from "./TabSeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports